export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,oklch(var(--primary-100)/0.3),transparent_50%)]" />

      <div className="relative w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-4 whitespace-nowrap">
              海量影视 · 免费在线观看
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold text-foreground-950 leading-tight">
              樱花TV<span className="text-primary-500">·</span>免费看剧追影首选平台
            </h1>

            <p className="mt-3 text-lg md:text-xl font-heading text-foreground-600">
              日剧美剧 · 国产电视剧 · 华语电影 · 欧美大片 — 高清全集不缓冲
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
              樱花TV汇聚海内外海量影视资源，覆盖日剧美剧、国产电视剧、华语电影与欧美大片，每日更新最新剧集与电影。无需注册、无需付费、高清流畅不缓冲，打开即看，零成本享受视听盛宴。当前热播《夏日烟火》《暗夜追踪》《长安十二时辰》等多部作品持续更新中。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-2 h-2 rounded-full bg-accent-500" />
                <span>每日更新 30+ 部</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-2 h-2 rounded-full bg-accent-500" />
                <span>覆盖 12 个国家地区</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <span className="w-2 h-2 rounded-full bg-accent-500" />
                <span>全高清 1080P 流畅播放</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-line text-lg" />
                立即观看
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-700 font-medium text-sm rounded-lg border border-background-300/60 hover:border-primary-300 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-grid-line text-lg" />
                探索分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20cinematic%20streaming%20platform%20visual%20with%20warm%20ambient%20lighting%2C%20featuring%20floating%20film%20strips%20and%20movie%20poster%20elements%20in%20a%20dark%20theater-like%20atmosphere%20with%20soft%20cherry%20blossom%20petals%2C%20elegant%20composition%2C%20cinematic%20color%20grading%20with%20deep%20reds%20and%20warm%20golds%2C%20sophisticated%20entertainment%20aesthetic&width=800&height=600&seq=hero-visual-sakura-tv&orientation=landscape"
                alt="樱花TV在线影视观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}